import {
  SET_IS_TILED_MENU,
  SET_TILED_MENU_IS_LOADED,
  SET_ACCORDION_IS_LOADED,
  SET_DASHBOARD_IS_LOADED,
  SET_HOMEPAGE_STORIES_IS_LOADED,
  SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  SET_SEARCH_RESULTS_LOADED,
  SET_ANNOTATIONS_LOADED,
  SET_HIDE_OVERRIDE
} from './types'
import { AppDispatch } from 'redux/store';

export const setIsTiledMenu = (isTiledMenu: boolean) => ({
  type: SET_IS_TILED_MENU,
  isTiledMenu
})

export const setTiledMenuIsLoaded = (isLoaded: boolean) => {
  return (dispatch:AppDispatch, _:any) => {
    // we want to set the tiled menu to false FIRST to stop random glitching
    !isLoaded && dispatch(setIsTiledMenu(false))
    dispatch({
      type: SET_TILED_MENU_IS_LOADED,
      isLoaded
    })
  }
}

export const setAccordionIsLoaded = (isLoaded: boolean) => ({
  type: SET_ACCORDION_IS_LOADED,
  isLoaded
})

export const setDashboardIsLoaded = (isLoaded: boolean) => ({
  type: SET_DASHBOARD_IS_LOADED,
  isLoaded
})

export const setHomePageStoriesIsLoaded = (isLoaded: boolean) => ({
  type: SET_HOMEPAGE_STORIES_IS_LOADED,
  isLoaded
})

export const setHomePageFcUpdatesIsLoaded = (isLoaded: boolean) => ({
  type: SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  isLoaded
})

export const setSearchResultsLoaded = (isLoaded: boolean) => ({
  type: SET_SEARCH_RESULTS_LOADED,
  isLoaded
})

export const setAnnotationsLoaded = (isLoaded: boolean) => ({
  type: SET_ANNOTATIONS_LOADED,
  isLoaded
})

// With AoL we can 404 on pages that exist but aren't available to the current user
export const setHideOverride = (hideOverride: boolean) => ({
  type: SET_HIDE_OVERRIDE,
  hideOverride
})
